
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";
import { Link } from "react-router-dom";
import { VerificationBadge } from "@/components/profile/VerificationBadge";

interface ReviewUserInfoProps {
  userId?: string;
  username: string | null;
  displayName?: string | null;
  avatarUrl?: string | null;
  verificationStatus?: 'none' | 'pending' | 'verified' | 'rejected' | 'verified_creative';
  isCreative?: boolean;
}

export const ReviewUserInfo = ({
  userId,
  username,
  displayName,
  avatarUrl,
  verificationStatus,
  isCreative
}: ReviewUserInfoProps) => {
  if (!userId) return null;
  
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2">
        <Link to={`/user/${userId}`} onClick={e => e.stopPropagation()} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <Avatar className="h-6 w-6">
            <AvatarImage src={avatarUrl || undefined} />
            <AvatarFallback>
              <User className="h-3 w-3" />
            </AvatarFallback>
          </Avatar>
          <span className="text-sm text-muted-foreground truncate px-0 py-0 my-0 mx-0">
            {displayName || username}
          </span>
        </Link>
        {verificationStatus && verificationStatus !== 'none' && (
          <VerificationBadge 
            status={verificationStatus} 
            isCreative={isCreative} 
            className="ml-1" 
          />
        )}
      </div>
    </div>
  );
}
